import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class NewsService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
             ) { }

    getNews() {
        return this.http.get(this.global.httpUrl+"news");
    }
    getNewsByFilter(filter: any[]) {
        let url = "";
        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }
        url = url.substring(0,url.length-1);
        return this.http.get(this.global.httpUrl + "news?" + url);
    }


    getNewsById(id: any) {
        return this.http.get(this.global.httpUrl+"news/"+id);
    } 

    createNews(data: any){
        return this.http.post(this.global.httpUrl+"news", data); 
    }

    updateNews(data: any,id: any){
        return this.http.put(this.global.httpUrl+"news/"+id, data); 
    } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/news/news.service.ts